import React, { useState, useEffect } from 'react';

const FadeInWrapper = ({ children, duration = 500 }) => {
  const [opacity, setOpacity] = useState(0);

  useEffect(() => {
    // Trigger fade-in animation on mount
    const timer = setTimeout(() => {
      setOpacity(1);
    }, 10); // Small delay to ensure transition works

    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      style={{
        opacity: opacity,
        transition: `opacity ${duration}ms ease-in`,
        width: '100%',
        height: '100%'
      }}
    >
      {children}
    </div>
  );
};

export default FadeInWrapper;

